import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CopySnippet = ({ code, testId }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(code); } catch (e) { /* clipboard blocked */ }
    setDone(true);
    setTimeout(() => setDone(false), 1800);
  };
  return (
    <div className="rounded-xl p-4 flex items-start gap-3" style={{ background: "var(--surface)", border: "1px solid var(--line-strong)" }}>
      <code data-testid={testId} className="text-xs font-mono text-[var(--text-soft)] break-all flex-1">{code}</code>
      <button data-testid={`${testId}-copy`} onClick={copy} className="flex items-center gap-1.5 text-xs text-[var(--red)] flex-shrink-0">{done ? <Check size={14} /> : <Copy size={14} />}{done ? "Copied" : "Copy"}</button>
    </div>
  );
};

export default CopySnippet;
